"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENUM_KEY_CODE = void 0;
/**
 * @internal
 */
var ENUM_KEY_CODE;
(function (ENUM_KEY_CODE) {
    ENUM_KEY_CODE[ENUM_KEY_CODE["KEY_CODE_ENTER"] = 13] = "KEY_CODE_ENTER";
    ENUM_KEY_CODE[ENUM_KEY_CODE["KEY_CODE_ESCAPE"] = 27] = "KEY_CODE_ESCAPE";
})(ENUM_KEY_CODE = exports.ENUM_KEY_CODE || (exports.ENUM_KEY_CODE = {}));
//# sourceMappingURL=utilities.js.map